import { createUserFeatureDecisions } from '@/services/features/userFeatureDecisions'

const getDefaultState = () => {
  return {
    toggles: {},
    userFeatureFlags: {},
    loadingCount: 0,
    crudLoadingCount: 0,
  }
}

const state = getDefaultState()

export default {
  namespaced: true,
  state,
  // IMPROVE: User Story 1380
  /**
   * IMPROVE: Remove front end feature flags (the ones present within config) and the feature toggle
   * decisions + factories as these are obsolete. We are opting for the BE to send feature flags moving forward.
   * @see {@link https://dev.azure.com/anzukeducation/Staffroom%20NEXT/_workitems/edit/1380 User Story 1380 }
   */
  getters: {
    moduleName: () => 'features',
    featureToggles: (state) => state.toggles,
    userFeatureFlags: (state) =>
      createUserFeatureDecisions(state.userFeatureFlags),
    isLoading: (state) => state.loadingCount > 0,
    isLoadingCRUD: (state) => state.crudLoadingCount > 0,
  },
  mutations: {
    START_LOADING(state) {
      state.loadingCount++
    },
    FINISH_LOADING(state) {
      state.loadingCount--
    },
    START_LOADING_CRUD(state) {
      state.crudLoadingCount++
    },
    FINISH_LOADING_CRUD(state) {
      state.crudLoadingCount--
    },
    CLEAR_STORE(state) {
      // Resets store to default state
      Object.assign(state, getDefaultState())
    },
    SET_FEATURE_TOGGLES(state, toggles) {
      state.toggles = toggles
    },
    SET_USER_FEATURE_FLAGS(state, flags) {
      state.userFeatureFlags = flags
    },
    DISABLE_FEATURE(state, featureFlag) {
      if (
        Object.prototype.hasOwnProperty.call(
          state.userFeatureFlags,
          featureFlag
        )
      )
        state.userFeatureFlags[featureFlag] = false
    },
  },
  actions: {
    /**
     * Feature flags from FE config.
     * This is an obsolete method for feature flagging and should not be used. Please use `setUserFeatureToggles`.
     * This should be removed in the future.
     */
    setFeatureToggles({ commit }, toggles) {
      commit('SET_FEATURE_TOGGLES', toggles)
    },
    /**
     * These are feature toggles comming from the backend
     */
    setUserFeatureFlags({ commit }, flags) {
      commit('SET_USER_FEATURE_FLAGS', flags)
    },
    /**
     * Disables a feature flag by its key
     * @param {{commit: Function}} context
     * @param {String} flag
     */
    disableFeatureFlag({ commit }, flag) {
      commit('DISABLE_FEATURE', flag)
    },
    /**
     * Resets store to default state.
     */
    clear({ commit }) {
      commit('CLEAR_STORE')
    },
  },
}
